import React, { useEffect, useRef, useState } from 'react'
import editIcon from '../../assets/icons/edit-icon.svg'
import Button from '../../components/button/Button'
import ParentDataTable from '../../components/data-table/ParentDataTable'
import useScreenSize from '../../hooks/useScreenSize'
import { ROUTES_PATH, UI_CONSTANT } from '../../utility/constants'
import BreadCrumbs from '../../components/breadcrumb/Breadcrumb'
import { useDispatch, useSelector } from 'react-redux'
import * as Yup from 'yup'
import {
  createBatch,
  getAllCourse,
  getBatchOptionList,
  getBranch,
  updateBatch,
} from '../../store/builders/branch/branch.builder'
import { VALIDATION_MESSAGES } from '../../utility/constantValidationMessages'
import { ErrorMessage, Formik } from 'formik'
import { convertDateFormatCalendar, generateDropdownOptions } from '../../utility/genricFunction'
import PageDropdown from '../../components/page-dropdown/PageDropdown'
import Calendar from '../../components/calendar/Calendar'
import NewInput from '../../components/input/NewInput'
import './batch.scss'
import { useParams } from 'react-router-dom'
import apiClient from '../../services/axois'
import Loader from '../../components/loader/Loader'
import { getCourseListByBranchId, getCourseListWithDraftByBranchId } from '../../store/builders/course/course.builder'
function ManageBatch() {
  const screenSize = useScreenSize()
  const { branchId } = useParams()
  const [batchId, setBatchId] = useState(null)
  const [initialValues, setInitialValues] = useState({
    branch: branchId,
    batch: null,
    course: null,
    startdate: null,
    enddate: null,
  })
  const dispatch = useDispatch()
  const { loading, branchTableData, batchListByBranchId } = useSelector((state) => state.branch)
  const { CourseListByDraftBranchId } = useSelector((state) => state.course)

  const branch = generateDropdownOptions(branchTableData, 'branchName', 'branchId')
  const formRef = useRef(null)
  useEffect(() => {
    dispatch(getCourseListWithDraftByBranchId(branchId))
    dispatch(getBranch())
    dispatch(getBatchOptionList(branchId))
    setBatchId(null)
  }, [])

  const handleEdit = async (id) => {
    setBatchId(id)
    const getBatchById = await apiClient.get(`/batchesById?batchId=${id}`)
    const batch = getBatchById.data.result.batches
    setInitialValues({
      branch: batch.branch_id,
      batch: batch.batch_no,
      course: batch.course_id,
      startdate: batch.start_date,
      enddate: batch.end_date,
    })
    if (formRef.current) {
      formRef.current.scrollIntoView({ behavior: 'smooth' })
    }
  }
  const actionBody = (rowData) => {
    return (
      <div className='action-body'>
        <Button className={'calendar-arrow right-icon'} onClick={() => handleEdit(rowData.batchId)}>
          <img src={editIcon} alt='Accept' />
        </Button>
      </div>
    )
  }
  const columns = [
    {
      sortable: false,
      field: 'branch.branchName',
      header: 'Branch',
      style: { minWidth: '12rem' },
    },
    {
      sortable: false,
      field: 'batchNo',
      header: 'Batch',
      style: { minWidth: '12rem' },
    },
    {
      sortable: false,
      field: '',
      header: 'Action',
      //   style: { minWidth: '12rem' },
      body: actionBody,
    },
  ]
  const breadCrumbsArr = [
    {
      title: UI_CONSTANT.MANAGE_BATCH,
      link: null,
    },
    {
      title: UI_CONSTANT.DASHBOARD,
      link: ROUTES_PATH.DASHBOARD,
    },
  ]
  const validationSchema = Yup.object().shape({
    course: Yup.string().required(VALIDATION_MESSAGES.COURSE_REQUIRED),
    branch: Yup.string().required(VALIDATION_MESSAGES.BRANCH_REQUIRED),
    batch: Yup.string().required(VALIDATION_MESSAGES.BATCH_REQUIRED),
    startdate: Yup.string()
      .required(VALIDATION_MESSAGES.START_DATE)
      .test('is-before-enddate', VALIDATION_MESSAGES.START_DATE_VALID, function (value) {
        const { enddate } = this.parent
        return !enddate || new Date(value) <= new Date(enddate)
      }),
    enddate: Yup.string().required(VALIDATION_MESSAGES.END_DATE),
  })

  const handleFormSubmit = (values, branchId, resetForm) => {
    if (batchId) {
      dispatch(updateBatch({ values, dispatch, branchId, batchId }))
      setBatchId(null)
      setInitialValues({
        branch: branchId,
        batch: '',
        course: null,
        startdate: null,
        enddate: null,
      })
      resetForm()
    } else {
      dispatch(createBatch({ values, dispatch, branchId }))
      resetForm()
      setInitialValues({
        branch: branchId,
        batch: '',
        course: null,
        startdate: null,
        enddate: null,
      })
    }
  }
  return (
    <>
      {loading && <Loader loading={loading} />}
      {/* <div className={`telephonic-container flex flex-column`}> */}
      {<Loader loading={loading} /> && (
        <div className={`course-list ${screenSize}`}>
          <div className='filter-bar-wraper'>
            <div className='subheader'>
              <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />
            </div>
          </div>
          <div className='batch-wrapper'>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={(values, { resetForm }) => {
                handleFormSubmit(values, branchId, resetForm)
              }}
              enableReinitialize
            >
              {({ values, handleChange, handleSubmit, setFieldValue }) => (
                <form ref={formRef} className='batch-form'>
                  <div className='batchform-inner-header'>
                    <h1>{UI_CONSTANT.BATCH.BATCH_INFORMATION}</h1>
                    <p>{UI_CONSTANT.BATCH.FORM_DESCRIPTION}</p>
                  </div>

                  <div className='separatorLine'></div>
                  <div className='full-form manage-batch'>
                    <div className='first-row batch-fields'>
                      <div className='first-field batch-input-field'>
                        <label className='branch-inp' htmlFor=''>
                          {UI_CONSTANT.BRANCH.LABEL_BRANCH}
                          <span className='required-symbol'>*</span>
                        </label>
                        <PageDropdown
                          options={branch}
                          selectedValue={values.branch}
                          disabled={true}
                          className={'enrollmentForm-dropdown'}
                          onChange={handleChange}
                          name={'branch'}
                          placeholder={'Select branch'}
                        />
                        <ErrorMessage name='branch' component='div' className='error-msg' />
                      </div>

                      <div className='first-field batch-input-field'>
                        <label className='branch-inp' htmlFor=''>
                          {UI_CONSTANT.BRANCH.LABEL_COURSE}
                          <span className='required-symbol'>*</span>
                        </label>
                        <PageDropdown
                          options={generateDropdownOptions(CourseListByDraftBranchId, 'courseName', 'courseId')}
                          selectedValue={values.course}
                          disabled={batchId ? true : false}
                          className={'enrollmentForm-dropdown'}
                          onChange={handleChange}
                          name={'course'}
                          placeholder={'Select course'}
                        />
                        <ErrorMessage name='course' component='div' className='error-msg' />
                      </div>

                      <NewInput
                        value={values.batch}
                        label='Batch'
                        name='batch'
                        width={'100%'}
                        onInput={handleChange}
                        placeholder={'Enter batch'}
                      />
                    </div>
                    <div className='first-row batch-calender-field'>
                      <Calendar
                        className={'w-32'}
                        value={values.startdate}
                        onChange={(values) => setFieldValue('startdate', convertDateFormatCalendar(values))}
                        name={'startdate'}
                        label={'Start Date'}
                        gap='0'
                        required={true}
                      />

                      <Calendar
                        className={'timetable-drawer-form-calendar'}
                        value={values.enddate}
                        onChange={(values) => setFieldValue('enddate', convertDateFormatCalendar(values))}
                        name={'enddate'}
                        label={'End Date'}
                        gap='0'
                        required={true}
                      />
                      <Button customClassName={'drawer-save-btn'} onClick={handleSubmit}>
                        {batchId ? 'Edit Batch' : 'Add Batch'}
                      </Button>
                    </div>
                  </div>
                </form>
              )}
            </Formik>
          </div>
          <div className='course-list'>
            <div className='group-parent'>
              <div className='frame-wrapper'>
                <div className='course-list-wrapper'>
                  <b className='course-list1'>{UI_CONSTANT.BATCH.ALL_BATCH}</b>
                </div>
              </div>
              <div className='table-card action-btn-include'>
                <ParentDataTable
                  value={batchListByBranchId}
                  rows={batchListByBranchId.length}
                  columns={columns}
                  pagination={false}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default ManageBatch
